import {breakpoints} from '../helpers/constants';
import {HighestHeight} from '../helpers/highest-height';

export class HighlightListHeight {

	constructor(elem) {
		this.elem = elem;
		this.selectorClass = this.elem.dataset.highestHeight;
		this.elements = this.selectorClass ? this.elem.querySelectorAll(`.${this.selectorClass}`) : false;
		this.draggable = this.elem.classList.contains('draggable');
		this.rows = this.handleRows();
		if (this.elements.length > 0) this.init();
	}

	init() {
		this.setHeightPerRow();
		this.addEventHandlers();
	}

	/**
	 * Splits the array of elements in different chunks, and then set the highest height in that row.
	 */
	setHeightPerRow() {
		this.chunkedArray = this.rows ? this.chunkArray(this.elements, this.rows) : false;
		if (this.chunkedArray) {
			for (let i = 0; i < this.chunkedArray.length; i++) {
				new HighestHeight(this.chunkedArray[i]);
			}
		}
	}

	/**
	 * All necessary event handlers
	 */
	addEventHandlers() {
		window.addEventListener('resize', () => {
			// Using timeout to prevent running these functions every resized pixel
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this.rows = this.handleRows();
				this.resetHeight();
				this.setHeightPerRow();
			}, 250);
		})
	}

	/**
	 * Divides the array in chunks based on the rows.
	 * @param elements
	 * @param perChunk
	 * @returns {[]}
	 */
	chunkArray(elements, perChunk) {
		elements = Array.prototype.slice.call(elements);
		let chunkedArray = [];
		let i, j, temparray, chunk = perChunk;
		for (i = 0, j = elements.length; i < j; i += chunk) {
			temparray = elements.slice(i, i + chunk);
			chunkedArray.push(temparray);
		}
		return chunkedArray;
	}

	/**
	 * Resets the height when resizing
	 */
	resetHeight() {
		for (let i = 0; i < this.elements.length; i++) {
			this.elements[i].style.minHeight = 'auto';
		}
	}

	/**
	 * Gets the amount of rows per chunk
	 * @returns {number}
	 */
	handleRows() {
		let rows;
		if (this.draggable) {
			rows = this.handleDraggableRows(rows);
		} else {
			rows = this.handleStaticRows(rows);
		}
		return rows;
	}

	/**
	 * Handles the static (non-draggable) rows;
	 * @param rows
	 * @returns {number|boolean}
	 */
	handleStaticRows(rows) {
		if (breakpoints.isSmall()) {
			rows = false;
		} else if (breakpoints.isMedium()) {
			rows = 2;
		} else {
			rows = 3;
		}
		return rows;
	}

	/**
	 * Handles the draggable rows
	 * @param rows
	 * @returns {number}
	 */
	handleDraggableRows(rows) {
		if (breakpoints.isMedium()) {
			rows = this.elements.length;
		} else {
			rows = 3;
		}
		return rows;
	}

	/**
	 * Using a class name so back-end change isn't necessary
	 * @returns {string}
	 */
	static getSelector() {
		return '.highlight-list[data-highest-height]';
	}
}
